import { graphql, useStaticQuery } from 'gatsby';

import { Universe } from 'src/types/gojob';

export const DefaultHeaderQuery = graphql`
  query DefaultHeader {
    sanityPage(slug: { current: { eq: "/" } }) {
      universe {
        ...HeaderFragment
      }
    }
  }
`;

const useDefaultHeader = () => {
  return useStaticQuery(DefaultHeaderQuery)?.sanityPage?.universe as Universe;
};

export default useDefaultHeader;
